import { CustomError } from '@pressreader/types';

export class FileNotFound extends CustomError {}

export class SelectFileCancelled extends CustomError {}
